export class NoAccessError {
    noaccesserr = {
        code: 'auth/no-access',
        message: 'Your account is not permitted to sign in to this application. Please contact your administrator.'
    };
}
